export enum AuthStep {
  Login = 'login',
  ResetPassword = 'reset-password',
  SubmitResetPassword = 'submit-reset-password',
  TwofaSetup = 'twofa-setup',
  TwofaVerify = 'twofa-verify',
  Authenticated = 'authenticated',
}
